var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 151171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 61,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9453 26.0048C12.9453 34.8201 20.2003 39.5178 25.5111 43.7225C27.3851 45.2063 29.1901 46.6032 30.9951 46.6032C32.8 46.6032 34.605 45.2063 36.4791 43.7225C41.7899 39.5178 49.0448 34.8201 49.0448 26.0048C49.0448 17.1893 39.1171 10.9375 30.9951 19.4126C22.873 10.9375 12.9453 17.1893 12.9453 26.0048Z",
    fill: "#ACACAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart_icon.d5f0e30627d2ff97c8ad222891cce131.svg";
export { ForwardRef as ReactComponent };